import {
  BalanceText,
  Button,
  Icon,
  IconButton,
  Shadow,
  Text,
  HStack,
  VStack,
} from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { messageError } from '../../../../../../store/batchTicket/constants';
import { ItemTag } from '../../../Customer/components/ItemTag';

import { getOffersQuantityText } from './constants';

import { TotalSummaryResponsiveItem } from '.';

export const TotalSummaryItemTablet: React.FC<TotalSummaryResponsiveItem> = ({
  handleRemoveCustomer,
  handleDetailsCustomer,
  handleExportItem,
  handleUpdateBalance,
  isLoadingBalance,
  item,
  detailsBasketItemButtonIsDisabled,
  availableBalance,
  allocatedBalanceField,
  remainingBalanceField,
}) => {
  return (
    <Shadow borderRadius={BoxRadius.xs} level={2}>
      <VStack space={Spacing['inline.xxxs']} p={Spacing['inline.xxs']} borderRadius={BoxRadius.xs}>
        <HStack alignItems="center" justifyContent="space-between">
          <VStack>
            <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {item?.customer?.customerName || messageError}
            </Text>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                Conta
              </Text>
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                {item?.customer?.account?.accountNumber || messageError}
              </Text>
              <TableContentItemCaptions forceDesktop icons={['ProfessionalInvestor']} />
            </HStack>
          </VStack>
          <HStack alignItems={'center'} space={Spacing['inline.xxxs']}>
            <TableContentItemBadge>
              {item?.customer?.suitabilityProfileName || 'conservador'}
            </TableContentItemBadge>
            <ItemTag
              isListing
              data={(item?.customer?.hashtags as never) || []}
              itemId={item?.customer?.account?.accountNumber}
            />
            {handleRemoveCustomer && (
              <IconButton
                testId="remove-icon-button"
                borderRadius={BoxRadius.sm}
                icon="Trash"
                onPress={handleRemoveCustomer}
                p={0}
                iconColor={Color['feedback.error.default']}
                iconSize="xs"
              />
            )}
            {handleExportItem && (
              <Button
                variant="textLink"
                onPress={handleExportItem}
                leftIcon={<Icon name="Pdf" size="xxxs" color={Color['brand.tertiary.principal']} />}
                _text={{
                  fontFamily: Typography['fontfamily.base.semibold'],
                  color: 'brand.tertiary.principal',
                }}>
                Exportar
              </Button>
            )}
          </HStack>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <VStack space={Spacing['stack.quarck']}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
              Ativos adicion.
            </Text>
            <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {getOffersQuantityText(item?.totalCustomerOffers)}
            </Text>
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
              Saldo disponível
            </Text>
            <BalanceText
              balance={availableBalance}
              lastUpdatedAt={new Date()}
              isUpdating={isLoadingBalance}
              textAlign="flex-start"
              hasUpdateButton
              onUpdateButtonPress={handleUpdateBalance}
              positiveBalanceColor="neutral.black"
              negativeBalanceColor="feedback.error.default"
            />
          </VStack>
          <VStack space={Spacing['stack.quarck']}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
              Saldo alocado | %
            </Text>
            <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {allocatedBalanceField}
            </Text>
          </VStack>
          <HStack alignItems={'center'} space={Spacing['inline.xxs']}>
            <VStack space={Spacing['stack.quarck']} alignItems={'flex-end'}>
              <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
                Saldo restante | %
              </Text>
              <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.darkest">
                {remainingBalanceField}
              </Text>
            </VStack>
            {handleDetailsCustomer && (
              <IconButton
                isDisabled={detailsBasketItemButtonIsDisabled}
                testId="details-icon-button"
                borderRadius={BoxRadius.sm}
                icon="ChevronRight"
                onPress={handleDetailsCustomer}
                p={0}
                iconColor={Color['brand.primary.principal']}
                iconSize="xs"
              />
            )}
          </HStack>
        </HStack>
      </VStack>
    </Shadow>
  );
};
